module.exports = __webpack_public_path__ + "img/icon_ccm_home_gerenciamentos.e10efd05.svg";